import PaymentAcceptTermsAndPrivacyController from './PaymentAcceptTermsAndPrivacyViewController';

export default PaymentAcceptTermsAndPrivacyController;
